import React from 'react'
import PropTypes from 'prop-types'

const AboutDescription = ({
    description,
    link,
}) => (
    <div className="about-description">
        <p>
            {description}
        </p>
        <a href={link} className="about-description-link">Check us out here</a>
    </div>
)

AboutDescription.propTypes = {
    description: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
}

export default AboutDescription
